import { render, staticRenderFns } from "./Meta_data.vue?vue&type=template&id=5c0b9b84"
import script from "./Meta_data.vue?vue&type=script&lang=js"
export * from "./Meta_data.vue?vue&type=script&lang=js"
import style0 from "./Meta_data.vue?vue&type=style&index=0&id=5c0b9b84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports